import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_130: DocMigration = {
  maxSchemaVersion: "0.0.130",
  description: "Roof wall base board",
  apply(json: any) {
    // exterior trim settings
    for (const settingsId in json.settings) {
      const settings = json.settings[settingsId];
      if (settings.type !== "EXTERIOR_TRIM_SETTINGS") {
        continue;
      }

      settings.wallRoofBaseBoard = "NONE";
    }

    return json;
  },
};

export default migration_0_0_130;
